exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#nemid_iframe, #codefile_iframe {\n  border: none;\n}\n.nemid-container {\n  margin-top: 0;\n}\n.nemid-container .tabs-component > ul {\n  border: none;\n  padding: 0 0 20px 0;\n  margin: 0;\n}", ""]);

// exports
